/* eslint-disable max-len */
export const LCI_FIELD_HINTS = {
  units:
    'Total number of units of this product manufactured across all sites during the reference period. Source: ERP, production planning, or operations records.',
  siteUnits:
    'Number of units of this product manufactured at this site during the reference period. For multi-site setups, all site values must sum to total units produced.',
  annualQuantity:
    'How much of this material you purchased from this supplier during the reference period. Source: purchase orders, supplier invoices, or procurement records.',
  quantity:
    'Total energy consumed at the entire facility during the reference period — from utility bills or fuel invoices, not per unit.',
  allocationBasis:
    'How shared facility energy and waste should be allocated to this product when multiple products are made at the same site.',
  facilityThroughput:
    'Total output of all products at this facility on the selected allocation basis during the reference period.',
  supplierCity:
    'City or region where the supplier ships from. Used to estimate transport distance to your manufacturing site.',
  destinationCity:
    'City or region where finished products are shipped. Used to estimate outbound transport distance.',
  expertMode:
    'Enable advanced fields such as manual emission factor overrides and renewable energy certificate (REC) inputs.',
  emissionFactor:
    'Automatically populated from the database unless you provide a supplier-specific value in Expert Mode.',
  noWasteJustification:
    'Brief note explaining why your manufacturing process generates no significant waste.',
  disposalRoutes:
    'Enter the percentage share for each end-of-life route. All percentages must sum to 100%.'
} as const;
